<div class="store-selector-container">
  <div class="store-selection-text">{{getString('storeSelection')}}</div>
  <div class="icons-container">
    <div class="icon-div tooltip-b" *ngFor="let store of stores; let i = index" [class.active]="isActive(store)" [class.icon-div_brand]="useBrandIcons">
      <img alt="" class="store-icon" [class.store-icon_appletv]="store == 'itunes' && !useBrandIcons" [class.store-icon_brand]="useBrandIcons" [src]="getIconPath(store)" (click)="select(store)" [class.not-clickable]="!isStoreSupported(store) || isStoreDeactivated(store)">
      <div class="store-name" [class.store-name-unavailable]="!isStoreSupported(store)">{{getStoreTitle(store)}}</div>
      <div class="headerDivider" *ngIf="i != stores.length-1"></div>

      <span class="tooltiptext-b" *ngIf="isStoreDeactivated(store)">{{getString('storeCurrentlyNotSupported')}}</span>
      <span class="tooltiptext-b" *ngIf="!isStoreSupported(store)">{{getString('storeNotAvailableInCountry')}}</span>

    </div>
  </div>
</div>
